import { render, staticRenderFns } from "./TrademarkStatusForm.vue?vue&type=template&id=7b7904e2&"
import script from "./TrademarkStatusForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkStatusForm.vue?vue&type=style&index=0&id=7b7904e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports